module.exports = __webpack_public_path__ + "img/sky-mary.09189223.jpeg";